/**
 * Form Utilities — Pure functions extracted VERBATIM from SimpleCopilotPanel.tsx
 * 
 * Used by: messageUtils.createBotMessage, useFormHandler
 * Risk: R18 (normalizeFormFields cross-hook dep) — mitigated by this shared util
 * 
 * SAFE REFACTORING: No logic changes. Functions copied exactly as-is.
 */

import { FormFieldsParser } from '../DataSource/FormFieldsParser';

/**
 * Normalize form fields from API response data
 * Verbatim from SimpleCopilotPanel.tsx L391-395
 */
export const normalizeFormFields = (data: any) => {
  if (!data) return undefined;
  const extractedFields = FormFieldsParser.extractFields(data);
  return extractedFields;
};
